export default { "columns":64,
 "image":"crystalcave-tileset.png",
 "imageheight":1024,
 "imagewidth":1024,
 "margin":0,
 "name":"crystalcave-tileset",
 "spacing":0,
 "tilecount":4096,
 "tiledversion":"1.12.1",
 "tileheight":16,
 "tiles":[
        {
         "id":90,
         "type":"decal"
        }, 
        {
         "id":91,
         "type":"decal"
        }, 
        {
         "id":92,
         "type":"decal"
        }, 
        {
         "id":149,
         "type":"decal"
        }, 
        {
         "id":150,
         "type":"decal"
        }, 
        {
         "id":151,
         "type":"decal"
        }, 
        {
         "id":153,
         "type":"decal"
        }, 
        {
         "id":154,
         "type":"decal"
        }, 
        {
         "id":155,
         "type":"decal"
        }, 
        {
         "id":156,
         "type":"decal"
        }, 
        {
         "id":200,
         "type":"decal"
        }, 
        {
         "id":201,
         "type":"decal"
        }, 
        {
         "id":202,
         "type":"decal"
        }, 
        {
         "id":203,
         "type":"decal"
        }, 
        {
         "id":204,
         "type":"decal"
        }, 
        {
         "id":205,
         "type":"decal"
        }, 
        {
         "id":206,
         "type":"decal"
        }, 
        {
         "id":207,
         "type":"decal"
        }, 
        {
         "id":208,
         "type":"decal"
        }, 
        {
         "id":209,
         "type":"decal"
        }, 
        {
         "id":210,
         "type":"decal"
        }, 
        {
         "id":211,
         "type":"decal"
        }, 
        {
         "id":212,
         "type":"decal"
        }, 
        {
         "id":213,
         "type":"decal"
        }, 
        {
         "id":214,
         "type":"decal"
        }, 
        {
         "id":215,
         "type":"decal"
        }, 
        {
         "id":216,
         "type":"decal"
        }, 
        {
         "id":217,
         "type":"decal"
        }, 
        {
         "id":218,
         "type":"decal"
        }, 
        {
         "id":219,
         "type":"decal"
        }, 
        {
         "id":220,
         "type":"decal"
        }, 
        {
         "id":264,
         "type":"decal"
        }, 
        {
         "id":265,
         "type":"decal"
        }, 
        {
         "id":266,
         "type":"decal"
        }, 
        {
         "id":267,
         "type":"decal"
        }, 
        {
         "id":268,
         "type":"decal"
        }, 
        {
         "id":269,
         "type":"decal"
        }, 
        {
         "id":270,
         "type":"decal"
        }, 
        {
         "id":271,
         "type":"decal"
        }, 
        {
         "id":272,
         "type":"decal"
        }, 
        {
         "id":273,
         "type":"decal"
        }, 
        {
         "id":274,
         "type":"decal"
        }, 
        {
         "id":275,
         "type":"decal"
        }, 
        {
         "id":276,
         "type":"decal"
        }, 
        {
         "id":277,
         "type":"decal"
        }, 
        {
         "id":278,
         "type":"decal"
        }, 
        {
         "id":279,
         "type":"decal"
        }, 
        {
         "id":280,
         "type":"decal"
        }, 
        {
         "id":281,
         "type":"decal"
        }, 
        {
         "id":282,
         "type":"decal"
        }, 
        {
         "id":283,
         "type":"decal"
        }, 
        {
         "id":284,
         "type":"decal"
        }, 
        {
         "id":285,
         "type":"decal"
        }, 
        {
         "id":330,
         "type":"decal"
        }, 
        {
         "id":331,
         "type":"decal"
        }, 
        {
         "id":332,
         "type":"decal"
        }, 
        {
         "id":333,
         "type":"decal"
        }, 
        {
         "id":334,
         "type":"decal"
        }, 
        {
         "id":335,
         "type":"decal"
        }, 
        {
         "id":336,
         "type":"decal"
        }, 
        {
         "id":337,
         "type":"decal"
        }, 
        {
         "id":338,
         "type":"decal"
        }, 
        {
         "id":339,
         "type":"decal"
        }, 
        {
         "id":340,
         "type":"decal"
        }, 
        {
         "id":341,
         "type":"decal"
        }, 
        {
         "id":342,
         "type":"decal"
        }, 
        {
         "id":343,
         "type":"decal"
        }, 
        {
         "id":344,
         "type":"decal"
        }, 
        {
         "id":345,
         "type":"decal"
        }, 
        {
         "id":346,
         "type":"decal"
        }, 
        {
         "id":347,
         "type":"decal"
        }, 
        {
         "id":348,
         "type":"decal"
        }, 
        {
         "id":349,
         "type":"decal"
        }, 
        {
         "id":521,
         "type":"ground"
        }, 
        {
         "id":523,
         "type":"ground"
        }, 
        {
         "id":527,
         "type":"decal"
        }, 
        {
         "id":528,
         "type":"decal"
        }, 
        {
         "id":529,
         "type":"decal"
        }, 
        {
         "id":530,
         "type":"decal"
        }, 
        {
         "id":531,
         "type":"decal"
        }, 
        {
         "id":532,
         "type":"decal"
        }, 
        {
         "id":533,
         "type":"decal"
        }, 
        {
         "id":534,
         "type":"decal"
        }, 
        {
         "id":535,
         "type":"decal"
        }, 
        {
         "id":536,
         "type":"decal"
        }, 
        {
         "id":537,
         "type":"decal"
        }, 
        {
         "id":538,
         "type":"decal"
        }, 
        {
         "id":539,
         "type":"decal"
        }, 
        {
         "id":543,
         "type":"ground"
        }, 
        {
         "id":545,
         "type":"ground"
        }, 
        {
         "id":585,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-12,
                             "y":5
                            }, 
                            {
                             "x":-12,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":12,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":587,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-1,
                             "y":9
                            }, 
                            {
                             "x":-15,
                             "y":15
                            }, 
                            {
                             "x":-15,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":15,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":591,
         "type":"ground"
        }, 
        {
         "id":592,
         "type":"ground"
        }, 
        {
         "id":593,
         "type":"ground"
        }, 
        {
         "id":594,
         "type":"ground"
        }, 
        {
         "id":595,
         "type":"ground"
        }, 
        {
         "id":596,
         "type":"ground"
        }, 
        {
         "id":597,
         "type":"ground"
        }, 
        {
         "id":598,
         "type":"ground"
        }, 
        {
         "id":599,
         "type":"ground"
        }, 
        {
         "id":600,
         "type":"ground"
        }, 
        {
         "id":601,
         "type":"ground"
        }, 
        {
         "id":602,
         "type":"ground"
        }, 
        {
         "id":603,
         "type":"ground"
        }, 
        {
         "id":607,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":15,
                             "y":0
                            }, 
                            {
                             "x":15,
                             "y":15
                            }, 
                            {
                             "x":1,
                             "y":9
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":1,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":609,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":12,
                             "y":0
                            }, 
                            {
                             "x":12,
                             "y":5
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":4,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":649,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":0,
                             "y":-16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":654,
         "type":"decal"
        }, 
        {
         "id":655,
         "type":"ground"
        }, 
        {
         "id":656,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-16,
                             "y":0
                            }, 
                            {
                             "x":-16,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":657,
         "type":"decal"
        }, 
        {
         "id":658,
         "type":"decal"
        }, 
        {
         "id":662,
         "type":"decal"
        }, 
        {
         "id":666,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":3,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":667,
         "type":"ground"
        }, 
        {
         "id":668,
         "type":"decal"
        }, 
        {
         "id":673,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":713,
         "type":"ground"
        }, 
        {
         "id":717,
         "type":"decal"
        }, 
        {
         "id":718,
         "type":"ground"
        }, 
        {
         "id":732,
         "type":"ground"
        }, 
        {
         "id":733,
         "type":"decal"
        }, 
        {
         "id":737,
         "type":"ground"
        }, 
        {
         "id":781,
         "objectgroup":
            {
             "draworder":"index",
             "id":3,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-10.2857142857143
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":0,
                             "y":-16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":782,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-12,
                             "y":5
                            }, 
                            {
                             "x":-12,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":12,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":796,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":12,
                             "y":0
                            }, 
                            {
                             "x":12,
                             "y":5
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":4,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":797,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":10.2857142857143
                            }, 
                            {
                             "x":16,
                             "y":-5.71428571428571
                            }, 
                            {
                             "x":0,
                             "y":-5.71428571428571
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":5.71428571428571
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":845,
         "type":"decal"
        }, 
        {
         "id":846,
         "type":"ground"
        }, 
        {
         "id":859,
         "type":"ground"
        }, 
        {
         "id":860,
         "type":"decal"
        }, 
        {
         "id":902,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":10,
                             "y":-16
                            }, 
                            {
                             "x":10,
                             "y":0
                            }, 
                            {
                             "x":-6,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":6,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":910,
         "type":"ground"
        }, 
        {
         "id":921,
         "type":"decal"
        }, 
        {
         "id":923,
         "type":"ground"
        }, 
        {
         "id":931,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":10,
                             "y":16
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":966,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":6,
                             "y":-9
                            }, 
                            {
                             "x":16,
                             "y":-9
                            }, 
                            {
                             "x":16,
                             "y":7
                            }, 
                            {
                             "x":0,
                             "y":7
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":9
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":974,
         "type":"ground"
        }, 
        {
         "id":987,
         "type":"ground"
        }, 
        {
         "id":995,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":6,
                             "y":9
                            }, 
                            {
                             "x":6,
                             "y":16
                            }, 
                            {
                             "x":-10,
                             "y":16
                            }, 
                            {
                             "x":-10,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":10,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":1030,
         "type":"ground"
        }, 
        {
         "id":1034,
         "type":"platform"
        }, 
        {
         "id":1035,
         "type":"platform"
        }, 
        {
         "id":1036,
         "type":"platform"
        }, 
        {
         "id":1038,
         "type":"ground"
        }, 
        {
         "id":1051,
         "type":"ground"
        }, 
        {
         "id":1053,
         "type":"platform"
        }, 
        {
         "id":1054,
         "type":"platform"
        }, 
        {
         "id":1055,
         "type":"platform"
        }, 
        {
         "id":1059,
         "type":"ground"
        }, 
        {
         "id":1102,
         "type":"ground"
        }, 
        {
         "id":1115,
         "type":"ground"
        }, 
        {
         "id":1156,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":1157,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":1158,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":1162,
         "type":"ground"
        }, 
        {
         "id":1163,
         "type":"ground"
        }, 
        {
         "id":1164,
         "type":"ground"
        }, 
        {
         "id":1165,
         "type":"decal"
        }, 
        {
         "id":1166,
         "type":"ground"
        }, 
        {
         "id":1179,
         "type":"ground"
        }, 
        {
         "id":1180,
         "type":"decal"
        }, 
        {
         "id":1181,
         "type":"ground"
        }, 
        {
         "id":1182,
         "type":"ground"
        }, 
        {
         "id":1183,
         "type":"ground"
        }, 
        {
         "id":1187,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":1188,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":1189,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":1220,
         "type":"ground"
        }, 
        {
         "id":1221,
         "type":"ground"
        }, 
        {
         "id":1222,
         "type":"ground"
        }, 
        {
         "id":1226,
         "type":"ground"
        }, 
        {
         "id":1227,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-12
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":0,
                             "y":-16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1228,
         "type":"decal"
        }, 
        {
         "id":1230,
         "type":"ground"
        }, 
        {
         "id":1243,
         "type":"ground"
        }, 
        {
         "id":1245,
         "type":"decal"
        }, 
        {
         "id":1246,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":12
                            }, 
                            {
                             "x":16,
                             "y":-4
                            }, 
                            {
                             "x":0,
                             "y":-4
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":4
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":1247,
         "type":"ground"
        }, 
        {
         "id":1251,
         "type":"ground"
        }, 
        {
         "id":1252,
         "type":"ground"
        }, 
        {
         "id":1253,
         "type":"ground"
        }, 
        {
         "id":1354,
         "type":"ground"
        }, 
        {
         "id":1355,
         "type":"ground"
        }, 
        {
         "id":1358,
         "type":"ground"
        }, 
        {
         "id":1371,
         "type":"ground"
        }, 
        {
         "id":1374,
         "type":"ground"
        }, 
        {
         "id":1375,
         "type":"ground"
        }, 
        {
         "id":1409,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-7
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":1410,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-7
                            }, 
                            {
                             "x":16,
                             "y":7
                            }, 
                            {
                             "x":0,
                             "y":7
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":9
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":1411,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":0,
                             "y":9
                            }, 
                            {
                             "x":-16,
                             "y":9
                            }, 
                            {
                             "x":-16,
                             "y":7
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":7
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":1413,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":0,
                             "y":9
                            }, 
                            {
                             "x":-16,
                             "y":9
                            }, 
                            {
                             "x":-16,
                             "y":7
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":7
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":1414,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":0,
                             "y":16
                            }, 
                            {
                             "x":-16,
                             "y":16
                            }, 
                            {
                             "x":-16,
                             "y":7
                            }, 
                            {
                             "x":-6,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":1415,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-7
                            }, 
                            {
                             "x":16,
                             "y":2
                            }, 
                            {
                             "x":0,
                             "y":2
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":14
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":1416,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-7
                            }, 
                            {
                             "x":16,
                             "y":9
                            }, 
                            {
                             "x":0,
                             "y":9
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":7
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":1422,
         "type":"ground"
        }, 
        {
         "id":1435,
         "type":"ground"
        }, 
        {
         "id":1442,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":7
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":1443,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":7
                            }, 
                            {
                             "x":16,
                             "y":9
                            }, 
                            {
                             "x":0,
                             "y":9
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":7
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":1444,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":7
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":1445,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":7
                            }, 
                            {
                             "x":16,
                             "y":9
                            }, 
                            {
                             "x":0,
                             "y":9
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":7
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":1447,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":7
                            }, 
                            {
                             "x":16,
                             "y":9
                            }, 
                            {
                             "x":0,
                             "y":9
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":7
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":1448,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":7
                            }, 
                            {
                             "x":16,
                             "y":14
                            }, 
                            {
                             "x":0,
                             "y":14
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":2
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":1449,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":7
                            }, 
                            {
                             "x":0,
                             "y":7
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":9
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":1473,
         "type":"ground"
        }, 
        {
         "id":1474,
         "type":"ground"
        }, 
        {
         "id":1475,
         "type":"ground"
        }, 
        {
         "id":1476,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-7
                            }, 
                            {
                             "x":16,
                             "y":9
                            }, 
                            {
                             "x":0,
                             "y":9
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":7
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagleft"
        }, 
        {
         "id":1477,
         "type":"ground"
        }, 
        {
         "id":1478,
         "type":"ground"
        }, 
        {
         "id":1479,
         "type":"ground"
        }, 
        {
         "id":1480,
         "type":"ground"
        }, 
        {
         "id":1482,
         "type":"ground"
        }, 
        {
         "id":1483,
         "type":"ground"
        }, 
        {
         "id":1485,
         "type":"decal"
        }, 
        {
         "id":1486,
         "type":"ground"
        }, 
        {
         "id":1499,
         "type":"ground"
        }, 
        {
         "id":1500,
         "type":"decal"
        }, 
        {
         "id":1502,
         "type":"ground"
        }, 
        {
         "id":1503,
         "type":"ground"
        }, 
        {
         "id":1506,
         "type":"ground"
        }, 
        {
         "id":1507,
         "type":"ground"
        }, 
        {
         "id":1508,
         "type":"ground"
        }, 
        {
         "id":1509,
         "type":"ground"
        }, 
        {
         "id":1510,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "opacity":1,
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":7
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"slopediagright"
        }, 
        {
         "id":1511,
         "type":"ground"
        }, 
        {
         "id":1512,
         "type":"ground"
        }, 
        {
         "id":1513,
         "type":"ground"
        }, 
        {
         "id":1537,
         "type":"ground"
        }, 
        {
         "id":1538,
         "type":"ground"
        }, 
        {
         "id":1539,
         "type":"ground"
        }, 
        {
         "id":1540,
         "type":"ground"
        }, 
        {
         "id":1541,
         "type":"ground"
        }, 
        {
         "id":1542,
         "type":"ground"
        }, 
        {
         "id":1543,
         "type":"ground"
        }, 
        {
         "id":1544,
         "type":"ground"
        }, 
        {
         "id":1546,
         "type":"ground"
        }, 
        {
         "id":1547,
         "type":"ground"
        }, 
        {
         "id":1549,
         "type":"decal"
        }, 
        {
         "id":1550,
         "type":"ground"
        }, 
        {
         "id":1563,
         "type":"ground"
        }, 
        {
         "id":1564,
         "type":"decal"
        }, 
        {
         "id":1566,
         "type":"ground"
        }, 
        {
         "id":1567,
         "type":"ground"
        }, 
        {
         "id":1570,
         "type":"ground"
        }, 
        {
         "id":1571,
         "type":"ground"
        }, 
        {
         "id":1572,
         "type":"ground"
        }, 
        {
         "id":1573,
         "type":"ground"
        }, 
        {
         "id":1574,
         "type":"ground"
        }, 
        {
         "id":1575,
         "type":"ground"
        }, 
        {
         "id":1576,
         "type":"ground"
        }, 
        {
         "id":1577,
         "type":"ground"
        }, 
        {
         "id":1613,
         "type":"decal"
        }, 
        {
         "id":1614,
         "type":"ground"
        }, 
        {
         "id":1627,
         "type":"ground"
        }, 
        {
         "id":1628,
         "type":"decal"
        }, 
        {
         "id":1677,
         "type":"decal"
        }, 
        {
         "id":1678,
         "type":"ground"
        }, 
        {
         "id":1680,
         "type":"decal"
        }, 
        {
         "id":1682,
         "type":"decal"
        }, 
        {
         "id":1684,
         "type":"decal"
        }, 
        {
         "id":1685,
         "type":"decal"
        }, 
        {
         "id":1686,
         "type":"decal"
        }, 
        {
         "id":1687,
         "type":"decal"
        }, 
        {
         "id":1688,
         "type":"decal"
        }, 
        {
         "id":1689,
         "type":"decal"
        }, 
        {
         "id":1691,
         "type":"ground"
        }, 
        {
         "id":1692,
         "type":"decal"
        }, 
        {
         "id":1742,
         "type":"decal"
        }, 
        {
         "id":1743,
         "type":"ground"
        }, 
        {
         "id":1744,
         "type":"ground"
        }, 
        {
         "id":1745,
         "type":"ground"
        }, 
        {
         "id":1746,
         "type":"ground"
        }, 
        {
         "id":1747,
         "type":"ground"
        }, 
        {
         "id":1748,
         "type":"ground"
        }, 
        {
         "id":1749,
         "type":"ground"
        }, 
        {
         "id":1750,
         "type":"ground"
        }, 
        {
         "id":1751,
         "type":"ground"
        }, 
        {
         "id":1752,
         "type":"ground"
        }, 
        {
         "id":1753,
         "type":"ground"
        }, 
        {
         "id":1754,
         "type":"ground"
        }, 
        {
         "id":1755,
         "type":"decal"
        }, 
        {
         "id":1805,
         "type":"decal"
        }, 
        {
         "id":1807,
         "type":"decal"
        }, 
        {
         "id":1808,
         "type":"decal"
        }, 
        {
         "id":1809,
         "type":"decal"
        }, 
        {
         "id":1810,
         "type":"decal"
        }, 
        {
         "id":1811,
         "type":"decal"
        }, 
        {
         "id":1812,
         "type":"decal"
        }, 
        {
         "id":1813,
         "type":"decal"
        }, 
        {
         "id":1814,
         "type":"decal"
        }, 
        {
         "id":1815,
         "type":"decal"
        }, 
        {
         "id":1816,
         "type":"decal"
        }, 
        {
         "id":1817,
         "type":"decal"
        }, 
        {
         "id":1818,
         "type":"decal"
        }, 
        {
         "id":1820,
         "type":"decal"
        }, 
        {
         "id":1993,
         "type":"decal"
        }, 
        {
         "id":1994,
         "type":"decal"
        }, 
        {
         "id":1995,
         "type":"decal"
        }, 
        {
         "id":1996,
         "type":"decal"
        }, 
        {
         "id":1997,
         "type":"decal"
        }, 
        {
         "id":1998,
         "type":"decal"
        }, 
        {
         "id":1999,
         "type":"decal"
        }, 
        {
         "id":2000,
         "type":"decal"
        }, 
        {
         "id":2001,
         "type":"decal"
        }, 
        {
         "id":2002,
         "type":"decal"
        }, 
        {
         "id":2003,
         "type":"decal"
        }, 
        {
         "id":2004,
         "type":"decal"
        }, 
        {
         "id":2005,
         "type":"decal"
        }, 
        {
         "id":2006,
         "type":"decal"
        }, 
        {
         "id":2007,
         "type":"decal"
        }, 
        {
         "id":2008,
         "type":"decal"
        }, 
        {
         "id":2009,
         "type":"decal"
        }, 
        {
         "id":2010,
         "type":"decal"
        }, 
        {
         "id":2011,
         "type":"decal"
        }, 
        {
         "id":2012,
         "type":"decal"
        }, 
        {
         "id":2057,
         "type":"decal"
        }, 
        {
         "id":2058,
         "type":"decal"
        }, 
        {
         "id":2059,
         "type":"decal"
        }, 
        {
         "id":2060,
         "type":"decal"
        }, 
        {
         "id":2061,
         "type":"decal"
        }, 
        {
         "id":2062,
         "type":"decal"
        }, 
        {
         "id":2063,
         "type":"decal"
        }, 
        {
         "id":2064,
         "type":"decal"
        }, 
        {
         "id":2065,
         "type":"decal"
        }, 
        {
         "id":2066,
         "type":"decal"
        }, 
        {
         "id":2067,
         "type":"decal"
        }, 
        {
         "id":2068,
         "type":"decal"
        }, 
        {
         "id":2069,
         "type":"decal"
        }, 
        {
         "id":2070,
         "type":"decal"
        }, 
        {
         "id":2071,
         "type":"decal"
        }, 
        {
         "id":2072,
         "type":"decal"
        }, 
        {
         "id":2073,
         "type":"decal"
        }, 
        {
         "id":2074,
         "type":"decal"
        }, 
        {
         "id":2075,
         "type":"decal"
        }, 
        {
         "id":2076,
         "type":"decal"
        }, 
        {
         "id":2077,
         "type":"decal"
        }, 
        {
         "id":2078,
         "type":"decal"
        }, 
        {
         "id":2122,
         "type":"decal"
        }, 
        {
         "id":2123,
         "type":"decal"
        }, 
        {
         "id":2124,
         "type":"decal"
        }, 
        {
         "id":2125,
         "type":"decal"
        }, 
        {
         "id":2126,
         "type":"decal"
        }, 
        {
         "id":2127,
         "type":"decal"
        }, 
        {
         "id":2128,
         "type":"decal"
        }, 
        {
         "id":2129,
         "type":"decal"
        }, 
        {
         "id":2130,
         "type":"decal"
        }, 
        {
         "id":2131,
         "type":"decal"
        }, 
        {
         "id":2132,
         "type":"decal"
        }, 
        {
         "id":2133,
         "type":"decal"
        }, 
        {
         "id":2134,
         "type":"decal"
        }, 
        {
         "id":2135,
         "type":"decal"
        }, 
        {
         "id":2136,
         "type":"decal"
        }, 
        {
         "id":2137,
         "type":"decal"
        }, 
        {
         "id":2138,
         "type":"decal"
        }, 
        {
         "id":2139,
         "type":"decal"
        }, 
        {
         "id":2140,
         "type":"decal"
        }, 
        {
         "id":2141,
         "type":"decal"
        }, 
        {
         "id":2142,
         "type":"decal"
        }, 
        {
         "id":2186,
         "type":"decal"
        }, 
        {
         "id":2187,
         "type":"decal"
        }, 
        {
         "id":2188,
         "type":"decal"
        }, 
        {
         "id":2189,
         "type":"decal"
        }, 
        {
         "id":2191,
         "type":"decal"
        }, 
        {
         "id":2192,
         "type":"decal"
        }, 
        {
         "id":2193,
         "type":"decal"
        }, 
        {
         "id":2241,
         "type":"decal"
        }, 
        {
         "id":2250,
         "type":"decal"
        }, 
        {
         "id":2251,
         "type":"decal"
        }, 
        {
         "id":2252,
         "type":"decal"
        }, 
        {
         "id":2269,
         "type":"decal"
        }, 
        {
         "id":2305,
         "type":"decal"
        }, 
        {
         "id":2333,
         "type":"decal"
        }, 
        {
         "id":2369,
         "type":"decal"
        }, 
        {
         "id":2371,
         "type":"decal"
        }, 
        {
         "id":2395,
         "type":"decal"
        }, 
        {
         "id":2397,
         "type":"decal"
        }, 
        {
         "id":2435,
         "type":"decal"
        }, 
        {
         "id":2436,
         "type":"decal"
        }, 
        {
         "id":2458,
         "type":"decal"
        }, 
        {
         "id":2459,
         "type":"decal"
        }, 
        {
         "id":2499,
         "type":"decal"
        }, 
        {
         "id":2500,
         "type":"decal"
        }, 
        {
         "id":2502,
         "type":"decal"
        }, 
        {
         "id":2503,
         "type":"decal"
        }, 
        {
         "id":2505,
         "type":"decal"
        }, 
        {
         "id":2507,
         "type":"decal"
        }, 
        {
         "id":2509,
         "type":"decal"
        }, 
        {
         "id":2510,
         "type":"decal"
        }, 
        {
         "id":2512,
         "type":"decal"
        }, 
        {
         "id":2513,
         "type":"decal"
        }, 
        {
         "id":2515,
         "type":"decal"
        }, 
        {
         "id":2517,
         "type":"decal"
        }, 
        {
         "id":2519,
         "type":"decal"
        }, 
        {
         "id":2520,
         "type":"decal"
        }, 
        {
         "id":2522,
         "type":"decal"
        }, 
        {
         "id":2523,
         "type":"decal"
        }, 
        {
         "id":2563,
         "type":"decal"
        }, 
        {
         "id":2564,
         "type":"decal"
        }, 
        {
         "id":2566,
         "type":"decal"
        }, 
        {
         "id":2567,
         "type":"decal"
        }, 
        {
         "id":2569,
         "type":"decal"
        }, 
        {
         "id":2571,
         "type":"decal"
        }, 
        {
         "id":2573,
         "type":"decal"
        }, 
        {
         "id":2574,
         "type":"decal"
        }, 
        {
         "id":2576,
         "type":"decal"
        }, 
        {
         "id":2577,
         "type":"decal"
        }, 
        {
         "id":2579,
         "type":"decal"
        }, 
        {
         "id":2581,
         "type":"decal"
        }, 
        {
         "id":2583,
         "type":"decal"
        }, 
        {
         "id":2584,
         "type":"decal"
        }, 
        {
         "id":2586,
         "type":"decal"
        }, 
        {
         "id":2587,
         "type":"decal"
        }, 
        {
         "id":2627,
         "type":"decal"
        }, 
        {
         "id":2628,
         "type":"decal"
        }, 
        {
         "id":2630,
         "type":"decal"
        }, 
        {
         "id":2631,
         "type":"decal"
        }, 
        {
         "id":2633,
         "type":"decal"
        }, 
        {
         "id":2635,
         "type":"decal"
        }, 
        {
         "id":2637,
         "type":"decal"
        }, 
        {
         "id":2638,
         "type":"decal"
        }, 
        {
         "id":2640,
         "type":"decal"
        }, 
        {
         "id":2641,
         "type":"decal"
        }, 
        {
         "id":2643,
         "type":"decal"
        }, 
        {
         "id":2645,
         "type":"decal"
        }, 
        {
         "id":2647,
         "type":"decal"
        }, 
        {
         "id":2648,
         "type":"decal"
        }, 
        {
         "id":2650,
         "type":"decal"
        }, 
        {
         "id":2651,
         "type":"decal"
        }, 
        {
         "id":2654,
         "type":"decal"
        }, 
        {
         "id":2655,
         "type":"decal"
        }, 
        {
         "id":2656,
         "type":"decal"
        }, 
        {
         "id":2680,
         "type":"decal"
        }, 
        {
         "id":2681,
         "type":"decal"
        }, 
        {
         "id":2682,
         "type":"decal"
        }, 
        {
         "id":2691,
         "type":"decal"
        }, 
        {
         "id":2692,
         "type":"decal"
        }, 
        {
         "id":2714,
         "type":"decal"
        }, 
        {
         "id":2715,
         "type":"decal"
        }, 
        {
         "id":2755,
         "type":"decal"
        }, 
        {
         "id":2756,
         "type":"decal"
        }, 
        {
         "id":2766,
         "type":"decal"
        }, 
        {
         "id":2767,
         "type":"decal"
        }, 
        {
         "id":2769,
         "type":"decal"
        }, 
        {
         "id":2770,
         "type":"decal"
        }, 
        {
         "id":2772,
         "type":"decal"
        }, 
        {
         "id":2773,
         "type":"decal"
        }, 
        {
         "id":2775,
         "type":"decal"
        }, 
        {
         "id":2776,
         "type":"decal"
        }, 
        {
         "id":2778,
         "type":"decal"
        }, 
        {
         "id":2779,
         "type":"decal"
        }, 
        {
         "id":2784,
         "type":"decal"
        }, 
        {
         "id":2785,
         "type":"decal"
        }, 
        {
         "id":2786,
         "type":"decal"
        }, 
        {
         "id":2787,
         "type":"decal"
        }, 
        {
         "id":2788,
         "type":"decal"
        }, 
        {
         "id":2789,
         "type":"decal"
        }, 
        {
         "id":2790,
         "type":"decal"
        }, 
        {
         "id":2791,
         "type":"decal"
        }, 
        {
         "id":2792,
         "type":"decal"
        }, 
        {
         "id":2794,
         "type":"decal"
        }, 
        {
         "id":2795,
         "type":"decal"
        }, 
        {
         "id":2797,
         "type":"decal"
        }, 
        {
         "id":2798,
         "type":"decal"
        }, 
        {
         "id":2800,
         "type":"decal"
        }, 
        {
         "id":2801,
         "type":"decal"
        }, 
        {
         "id":2802,
         "type":"decal"
        }, 
        {
         "id":2803,
         "type":"decal"
        }, 
        {
         "id":2804,
         "type":"decal"
        }, 
        {
         "id":2805,
         "type":"decal"
        }, 
        {
         "id":2806,
         "type":"decal"
        }, 
        {
         "id":2807,
         "type":"decal"
        }, 
        {
         "id":2808,
         "type":"decal"
        }, 
        {
         "id":2819,
         "type":"decal"
        }, 
        {
         "id":2820,
         "type":"decal"
        }, 
        {
         "id":2822,
         "type":"decal"
        }, 
        {
         "id":2824,
         "type":"decal"
        }, 
        {
         "id":2826,
         "type":"decal"
        }, 
        {
         "id":2828,
         "type":"decal"
        }, 
        {
         "id":2830,
         "type":"decal"
        }, 
        {
         "id":2831,
         "type":"decal"
        }, 
        {
         "id":2833,
         "type":"decal"
        }, 
        {
         "id":2834,
         "type":"decal"
        }, 
        {
         "id":2836,
         "type":"decal"
        }, 
        {
         "id":2837,
         "type":"decal"
        }, 
        {
         "id":2839,
         "type":"decal"
        }, 
        {
         "id":2840,
         "type":"decal"
        }, 
        {
         "id":2842,
         "type":"decal"
        }, 
        {
         "id":2843,
         "type":"decal"
        }, 
        {
         "id":2849,
         "type":"decal"
        }, 
        {
         "id":2850,
         "type":"decal"
        }, 
        {
         "id":2851,
         "type":"decal"
        }, 
        {
         "id":2852,
         "type":"decal"
        }, 
        {
         "id":2853,
         "type":"decal"
        }, 
        {
         "id":2854,
         "type":"decal"
        }, 
        {
         "id":2855,
         "type":"decal"
        }, 
        {
         "id":2856,
         "type":"decal"
        }, 
        {
         "id":2859,
         "type":"decal"
        }, 
        {
         "id":2861,
         "type":"decal"
        }, 
        {
         "id":2864,
         "type":"decal"
        }, 
        {
         "id":2865,
         "type":"decal"
        }, 
        {
         "id":2866,
         "type":"decal"
        }, 
        {
         "id":2867,
         "type":"decal"
        }, 
        {
         "id":2868,
         "type":"decal"
        }, 
        {
         "id":2869,
         "type":"decal"
        }, 
        {
         "id":2870,
         "type":"decal"
        }, 
        {
         "id":2871,
         "type":"decal"
        }, 
        {
         "id":2883,
         "type":"decal"
        }, 
        {
         "id":2884,
         "type":"decal"
        }, 
        {
         "id":2906,
         "type":"decal"
        }, 
        {
         "id":2907,
         "type":"decal"
        }, 
        {
         "id":2950,
         "type":"decal"
        }, 
        {
         "id":2952,
         "type":"decal"
        }, 
        {
         "id":2954,
         "type":"decal"
        }, 
        {
         "id":2956,
         "type":"decal"
        }, 
        {
         "id":2958,
         "type":"decal"
        }, 
        {
         "id":2959,
         "type":"decal"
        }, 
        {
         "id":2960,
         "type":"decal"
        }, 
        {
         "id":2961,
         "type":"decal"
        }, 
        {
         "id":2962,
         "type":"decal"
        }, 
        {
         "id":2963,
         "type":"decal"
        }, 
        {
         "id":2965,
         "type":"decal"
        }, 
        {
         "id":2967,
         "type":"decal"
        }, 
        {
         "id":2978,
         "type":"decal"
        }, 
        {
         "id":2979,
         "type":"decal"
        }, 
        {
         "id":2980,
         "type":"decal"
        }, 
        {
         "id":2996,
         "type":"decal"
        }, 
        {
         "id":2997,
         "type":"decal"
        }, 
        {
         "id":2998,
         "type":"decal"
        }, 
        {
         "id":3011,
         "type":"decal"
        }, 
        {
         "id":3022,
         "type":"decal"
        }, 
        {
         "id":3023,
         "type":"decal"
        }, 
        {
         "id":3024,
         "type":"decal"
        }, 
        {
         "id":3025,
         "type":"decal"
        }, 
        {
         "id":3026,
         "type":"decal"
        }, 
        {
         "id":3027,
         "type":"decal"
        }, 
        {
         "id":3035,
         "type":"decal"
        }, 
        {
         "id":3042,
         "type":"decal"
        }, 
        {
         "id":3043,
         "type":"decal"
        }, 
        {
         "id":3044,
         "type":"decal"
        }, 
        {
         "id":3060,
         "type":"decal"
        }, 
        {
         "id":3061,
         "type":"decal"
        }, 
        {
         "id":3062,
         "type":"decal"
        }, 
        {
         "id":3075,
         "type":"decal"
        }, 
        {
         "id":3076,
         "type":"decal"
        }, 
        {
         "id":3078,
         "type":"decal"
        }, 
        {
         "id":3080,
         "type":"decal"
        }, 
        {
         "id":3082,
         "type":"decal"
        }, 
        {
         "id":3084,
         "type":"decal"
        }, 
        {
         "id":3086,
         "type":"decal"
        }, 
        {
         "id":3087,
         "type":"decal"
        }, 
        {
         "id":3088,
         "type":"decal"
        }, 
        {
         "id":3089,
         "type":"decal"
        }, 
        {
         "id":3090,
         "type":"decal"
        }, 
        {
         "id":3091,
         "type":"decal"
        }, 
        {
         "id":3093,
         "type":"decal"
        }, 
        {
         "id":3095,
         "type":"decal"
        }, 
        {
         "id":3098,
         "type":"decal"
        }, 
        {
         "id":3099,
         "type":"decal"
        }, 
        {
         "id":3111,
         "type":"decal"
        }, 
        {
         "id":3112,
         "type":"decal"
        }, 
        {
         "id":3113,
         "type":"decal"
        }, 
        {
         "id":3114,
         "type":"decal"
        }, 
        {
         "id":3150,
         "type":"decal"
        }, 
        {
         "id":3151,
         "type":"decal"
        }, 
        {
         "id":3152,
         "type":"decal"
        }, 
        {
         "id":3153,
         "type":"decal"
        }, 
        {
         "id":3154,
         "type":"decal"
        }, 
        {
         "id":3155,
         "type":"decal"
        }, 
        {
         "id":3170,
         "type":"decal"
        }, 
        {
         "id":3171,
         "type":"decal"
        }, 
        {
         "id":3172,
         "type":"decal"
        }, 
        {
         "id":3175,
         "type":"decal"
        }, 
        {
         "id":3176,
         "type":"decal"
        }, 
        {
         "id":3177,
         "type":"decal"
        }, 
        {
         "id":3178,
         "type":"decal"
        }, 
        {
         "id":3188,
         "type":"decal"
        }, 
        {
         "id":3189,
         "type":"decal"
        }, 
        {
         "id":3190,
         "type":"decal"
        }, 
        {
         "id":3203,
         "type":"decal"
        }, 
        {
         "id":3204,
         "type":"decal"
        }, 
        {
         "id":3206,
         "type":"decal"
        }, 
        {
         "id":3208,
         "type":"decal"
        }, 
        {
         "id":3210,
         "type":"decal"
        }, 
        {
         "id":3212,
         "type":"decal"
        }, 
        {
         "id":3221,
         "type":"decal"
        }, 
        {
         "id":3223,
         "type":"decal"
        }, 
        {
         "id":3226,
         "type":"decal"
        }, 
        {
         "id":3227,
         "type":"decal"
        }, 
        {
         "id":3239,
         "type":"decal"
        }, 
        {
         "id":3240,
         "type":"decal"
        }, 
        {
         "id":3241,
         "type":"decal"
        }, 
        {
         "id":3242,
         "type":"decal"
        }, 
        {
         "id":3267,
         "type":"decal"
        }, 
        {
         "id":3278,
         "type":"decal"
        }, 
        {
         "id":3279,
         "type":"decal"
        }, 
        {
         "id":3280,
         "type":"decal"
        }, 
        {
         "id":3281,
         "type":"decal"
        }, 
        {
         "id":3282,
         "type":"decal"
        }, 
        {
         "id":3283,
         "type":"decal"
        }, 
        {
         "id":3291,
         "type":"decal"
        }, 
        {
         "id":3298,
         "type":"decal"
        }, 
        {
         "id":3299,
         "type":"decal"
        }, 
        {
         "id":3300,
         "type":"decal"
        }, 
        {
         "id":3303,
         "type":"decal"
        }, 
        {
         "id":3304,
         "type":"decal"
        }, 
        {
         "id":3305,
         "type":"decal"
        }, 
        {
         "id":3306,
         "type":"decal"
        }, 
        {
         "id":3316,
         "type":"decal"
        }, 
        {
         "id":3317,
         "type":"decal"
        }, 
        {
         "id":3318,
         "type":"decal"
        }, 
        {
         "id":3342,
         "type":"decal"
        }, 
        {
         "id":3343,
         "type":"decal"
        }, 
        {
         "id":3344,
         "type":"decal"
        }, 
        {
         "id":3345,
         "type":"decal"
        }, 
        {
         "id":3346,
         "type":"decal"
        }, 
        {
         "id":3347,
         "type":"decal"
        }, 
        {
         "id":3349,
         "type":"decal"
        }, 
        {
         "id":3351,
         "type":"decal"
        }, 
        {
         "id":3395,
         "type":"decal"
        }, 
        {
         "id":3396,
         "type":"decal"
        }, 
        {
         "id":3406,
         "type":"decal"
        }, 
        {
         "id":3407,
         "type":"decal"
        }, 
        {
         "id":3408,
         "type":"decal"
        }, 
        {
         "id":3409,
         "type":"decal"
        }, 
        {
         "id":3410,
         "type":"decal"
        }, 
        {
         "id":3411,
         "type":"decal"
        }, 
        {
         "id":3418,
         "type":"decal"
        }, 
        {
         "id":3419,
         "type":"decal"
        }, 
        {
         "id":3426,
         "type":"decal"
        }, 
        {
         "id":3427,
         "type":"decal"
        }, 
        {
         "id":3428,
         "type":"decal"
        }, 
        {
         "id":3431,
         "type":"decal"
        }, 
        {
         "id":3432,
         "type":"decal"
        }, 
        {
         "id":3444,
         "type":"decal"
        }, 
        {
         "id":3445,
         "type":"decal"
        }, 
        {
         "id":3446,
         "type":"decal"
        }, 
        {
         "id":3459,
         "type":"decal"
        }, 
        {
         "id":3460,
         "type":"decal"
        }, 
        {
         "id":3470,
         "type":"decal"
        }, 
        {
         "id":3471,
         "type":"decal"
        }, 
        {
         "id":3472,
         "type":"decal"
        }, 
        {
         "id":3473,
         "type":"decal"
        }, 
        {
         "id":3474,
         "type":"decal"
        }, 
        {
         "id":3475,
         "type":"decal"
        }, 
        {
         "id":3482,
         "type":"decal"
        }, 
        {
         "id":3483,
         "type":"decal"
        }, 
        {
         "id":3490,
         "type":"decal"
        }, 
        {
         "id":3491,
         "type":"decal"
        }, 
        {
         "id":3492,
         "type":"decal"
        }, 
        {
         "id":3495,
         "type":"decal"
        }, 
        {
         "id":3496,
         "type":"decal"
        }, 
        {
         "id":3508,
         "type":"decal"
        }, 
        {
         "id":3509,
         "type":"decal"
        }, 
        {
         "id":3510,
         "type":"decal"
        }, 
        {
         "id":3523,
         "type":"decal"
        }, 
        {
         "id":3524,
         "type":"decal"
        }, 
        {
         "id":3546,
         "type":"decal"
        }, 
        {
         "id":3547,
         "type":"decal"
        }, 
        {
         "id":3587,
         "type":"decal"
        }, 
        {
         "id":3588,
         "type":"decal"
        }, 
        {
         "id":3610,
         "type":"decal"
        }, 
        {
         "id":3611,
         "type":"decal"
        }, 
        {
         "id":3651,
         "type":"decal"
        }, 
        {
         "id":3652,
         "type":"decal"
        }, 
        {
         "id":3654,
         "type":"decal"
        }, 
        {
         "id":3655,
         "type":"decal"
        }, 
        {
         "id":3657,
         "type":"decal"
        }, 
        {
         "id":3659,
         "type":"decal"
        }, 
        {
         "id":3661,
         "type":"decal"
        }, 
        {
         "id":3662,
         "type":"decal"
        }, 
        {
         "id":3664,
         "type":"decal"
        }, 
        {
         "id":3665,
         "type":"decal"
        }, 
        {
         "id":3667,
         "type":"decal"
        }, 
        {
         "id":3669,
         "type":"decal"
        }, 
        {
         "id":3671,
         "type":"decal"
        }, 
        {
         "id":3672,
         "type":"decal"
        }, 
        {
         "id":3674,
         "type":"decal"
        }, 
        {
         "id":3675,
         "type":"decal"
        }, 
        {
         "id":3715,
         "type":"decal"
        }, 
        {
         "id":3716,
         "type":"decal"
        }, 
        {
         "id":3718,
         "type":"decal"
        }, 
        {
         "id":3719,
         "type":"decal"
        }, 
        {
         "id":3721,
         "type":"decal"
        }, 
        {
         "id":3723,
         "type":"decal"
        }, 
        {
         "id":3725,
         "type":"decal"
        }, 
        {
         "id":3726,
         "type":"decal"
        }, 
        {
         "id":3728,
         "type":"decal"
        }, 
        {
         "id":3729,
         "type":"decal"
        }, 
        {
         "id":3731,
         "type":"decal"
        }, 
        {
         "id":3733,
         "type":"decal"
        }, 
        {
         "id":3735,
         "type":"decal"
        }, 
        {
         "id":3736,
         "type":"decal"
        }, 
        {
         "id":3738,
         "type":"decal"
        }, 
        {
         "id":3739,
         "type":"decal"
        }, 
        {
         "id":3779,
         "type":"decal"
        }, 
        {
         "id":3780,
         "type":"decal"
        }, 
        {
         "id":3782,
         "type":"decal"
        }, 
        {
         "id":3783,
         "type":"decal"
        }, 
        {
         "id":3785,
         "type":"decal"
        }, 
        {
         "id":3787,
         "type":"decal"
        }, 
        {
         "id":3789,
         "type":"decal"
        }, 
        {
         "id":3790,
         "type":"decal"
        }, 
        {
         "id":3792,
         "type":"decal"
        }, 
        {
         "id":3793,
         "type":"decal"
        }, 
        {
         "id":3795,
         "type":"decal"
        }, 
        {
         "id":3797,
         "type":"decal"
        }, 
        {
         "id":3799,
         "type":"decal"
        }, 
        {
         "id":3800,
         "type":"decal"
        }, 
        {
         "id":3802,
         "type":"decal"
        }, 
        {
         "id":3803,
         "type":"decal"
        }, 
        {
         "id":3843,
         "type":"decal"
        }, 
        {
         "id":3844,
         "type":"decal"
        }, 
        {
         "id":3866,
         "type":"decal"
        }, 
        {
         "id":3867,
         "type":"decal"
        }, 
        {
         "id":3905,
         "type":"decal"
        }, 
        {
         "id":3907,
         "type":"decal"
        }, 
        {
         "id":3931,
         "type":"decal"
        }, 
        {
         "id":3933,
         "type":"decal"
        }, 
        {
         "id":3969,
         "type":"decal"
        }, 
        {
         "id":3997,
         "type":"decal"
        }, 
        {
         "id":4033,
         "type":"decal"
        }, 
        {
         "id":4061,
         "type":"decal"
        }],
 "tilewidth":16,
 "type":"tileset",
 "version":"1.10"
};